import { ids } from "../../helpers/rolAccess";
import { paths } from "../../config/routes";
import apiConfig from "../../config/api";

const menuWorker = [
  {
    name: "Mis siniestros",
    route: paths.siniestros,
    icon: "I",
    tourId: "trabajador_siniestros",
  },
  {
    //name: "Capacitaciones",
    name: "Capacitaciones E-learning",
    route: "/capacitaciones",
    accessId: ids.capacitaciones,
    icon: "(",
    url: `${apiConfig.capacitacionesUri}`,
  },
  {
    name: 'Resultados exámenes de salud',
    accessId: ids.examenes,
    icon: "#",
    url: `${apiConfig.resultadoExamenesTrabajador}`,
    skiptoken: true
  },
  {
    name: 'Pagos pendientes',
    accessId: ids.pagosPendientes,
    icon: "?",
    url: `${apiConfig.pagosPendientes}`,
    skiptoken: true
  },
  {
    name: 'Estado pensión e indemnización',
    accessId: ids.estadoPension,
    icon: "\\",
    url: `${apiConfig.estadoPension}`,
    skiptoken: true
  },
  {
    name: 'Tus beneficios en Mundo ACHS',
    accessId: ids.mundoAchs,
    icon: "E",
    url: `${apiConfig.mundoAchsUrl}`,
    skiptoken: true
  },
];

const menuCompany = [
  {
    name: "ACHS Gestión",
    accessId: ids.achsGestion,
    icon: "!",
    url: `${apiConfig.redUri}`, //Nuevo item
    skiptoken: true,
  },
  {
    name: "COVID-19",
    route: paths.panelCovid19,
    icon: "_",
    accessId: ids.siniestrosEmpresa,
  },
  {
    name: "Datos empresa",
    route: paths.miEmpresa,
    accessId: ids.resumenEmpresa,
    icon: "v",
    tourId: "empresa_datos",
  },
  {
    name: "Gestionar usuarios",
    route: paths.gestionarUsuario,
    accessId: ids.gestionarUsuarios,
    icon: "C",
    tourId: "empresa_gestionar",
  },
  {
    name: "Siniestros",
    route: paths.siniestrosEmpresa,
    accessId: ids.siniestrosEmpresa,
    icon: "I",
    tourId: "empresa_siniestros",
  },
  // {
  //   name: "Gestión Cursos E-Learning",
  //   accessId: ids.gestionarCapacitaciones,
  //   icon: "H",
  //   //iconFile: personPlus,
  //   url: `${apiConfig.gestionarCapacitaciones}`, //Nuevo item
  // },
  {
    name: 'Tus beneficios en Mundo ACHS',
    accessId: ids.mundoAchsEmpresa,
    icon: "E",
    url: `${apiConfig.mundoAchsEmpresaUrl}`,
    skiptoken: true
  },
  {
    name: "Plan de Movilidad",
    route: paths.planMovilidad,
    icon: "u",
    accessId: ids.movilidad,
  },
  {
    name: "Cotizaciones",
    route: paths.cotizaciones,
    icon: "J",
    accessId: ids.cotizacionesEmpresa,
  },
  {
    name: "Denuncias",
    route: "/denuncias",
    accessId: ids.portalEmpresa,
    icon: "s",
    tourId: "empresa_seguros",
    tourSection: true,
    url: `${apiConfig.denunciasUri}`,
  },
  {
    name: "Prestaciones económicas",
    route: "/prestacioneseconomicas",
    accessId: ids.portalEmpresa,
    icon: "t",
    tourId: "empresa_seguros",
    tourSection: true,
    url: `${apiConfig.prestacionesUri}`,
  },
  {
    name: "Certificados",
    route: "/certificados",
    accessId: ids.certificadosSEL,
    icon: "x",
    tourId: "empresa_certificados",
    tourSection: true,
    url: `${apiConfig.certificadosUri}`,
  },
  {
    name: "Devoluciones",
    route: "/devoluciones",
    accessId: ids.portalEmpresa,
    icon: "J",
    tourId: "empresa_devoluciones",
    tourSection: true,
    url: `${apiConfig.devolucionesUri}`,
  },
  {
    name: "Prevención",
    route: "/prevencion",
    accessId: ids.portalEmpresa,
    icon: "K",
    tourId: "empresa_prevencion",
    tourSection: true,
    url: `${apiConfig.prevencionUri}`,
  },
  {
    name: "Lesiones graves y fatales",
    accessId: ids.portalEmpresa,
    icon: ":",
    tourId: "empresa_seguros",
    tourSection: true,
    url: `${apiConfig.LFGUrl}`,
  },
  {
    name: "Estadísticas",
    route: "/stats",
    accessId: ids.portalEmpresa,
    icon: "g",
    tourId: "empresa_estadisticas",
    tourSection: true,
    url: `${apiConfig.estadisticasUri}`,
  },
  {
    name: "Decreto supremo N°67",
    route: "/decreto",
    accessId: ids.portalEmpresa,
    icon: "w",
    tourId: "empresa_decreto",
    tourSection: true,
    url: `${apiConfig.ds67Uri}`,
  },
  {
    name: "Autoevaluación Legal",
    route: "/autoevaluacion",
    accessId: ids.autoevaluacion,
    icon: "0",
    tourId: "empresa_decreto",
    tourSection: true,
    url: `${apiConfig.autoevaluacionUri}`, //Nuevo item
    evaluarIndependiente: true,
  },
  {
    name: "Agendamiento experto",
    accessId: ids.agendamientoExperto,
    icon: "b",
    url: `${apiConfig.agendamientoExperto}`, //Nuevo item
    agendamientoExperto: true,
  },
  {
    name: "Gestión Cursos E-Learning",
    accessId: ids.gestionarCapacitaciones,
    icon: "H",
    //iconFile: personPlus,
    url: `${apiConfig.gestionarCapacitaciones}`, //Nuevo item
  },
];

const menuSEL = [
  {
    name: "Agenda SEL",
    route: paths.agendaSel,
    icon: "b",
    accessId: ids.agendaSel,
  },
  {
    name: "Inbox de solicitudes",
    route: paths.inboxSolicitudesSel,
    icon: "k",
    accessId: ids.callCenter,
  },
];

export default [
  {
    name: "Inicio",
    icon: "A",
    tourId: "inicio_main_menu",
    route: paths.root,
    noExpand: true,
    subMenu: [],
  },

  {
    name: "Trabajador",
    tourId: "trabajador_main_menu",
    icon: "C",
    description: 'Visualizarás la oferta de cursos y capacitaciones, además de información de tus accidentes, enfermedades y prestaciones económicas.',
    route: paths.siniestros,
    subMenu: menuWorker,
  },
  {
    name: "Empresa",
    tourId: "empresa_main_menu",
    icon: "D",
    description: 'Accede a los distintos productos, servicios y estadísticas que ofrecemos como empresa afiliada a la ACHS.',
    showSelects: true,
    accessId: ids.miEmpresa,
    route: paths.siniestrosEmpresa,
    subMenu: menuCompany,
  },
  /*{
    name: "Beneficios",
    icon: "E",
    tourId: "beneficios_main_menu",
    noClick: true,
    subMenu: [
      {
        name: "Beneficios", route: "/bene", icon: "E", tourId: "beneficios_beneficios", url: "http://www.mundoachs.cl/",
      },
    ],
  },*/
  {
    name: "Soporte",
    icon: "F",
    tourId: "soporte_main_menu",
    // route: paths.faq,
    noClick: true,
    description: 'Accede a infografías, videos, tour guiado y  material que te ayudará a encontrar lo que buscas en ACHS Virtual. Además, resuelve tus dudas con el chat que tenemos en línea.',
    subMenu: [
      // {
      //   name: "Preguntas frecuentes", icon: "P", route: paths.faq, tourId: "inicio_faq",
      // },
      {
        name: "Tour guiado",
        icon: "y",
        tour: true,
        tourId: "inicio_tour",
      },
      // {
      //   name: "Sedes ACHS", icon: "O", tourId: "soporte_sucursales", url: "https://www.achs.cl/portal/Paginas/Sedes.aspx",
      // },
      // {
      //   name: "Chat", route: "/chat", icon: "F", tourId: "soporte_reclamos",
      // },
      {
        name: "Material soporte",
        icon: "3",
        tourId: "soporte_reclamos",
        url: "https://www.achs.cl/portal/Paginas/Soporte_Achs_Virtual.aspx",
        skiptoken: true,
      },
      {
        name: "¿Necesitas ayuda?",
        icon: "[",
        skiptoken: true,
      },
    ],
  },
  {
    name: "SEL",
    tourId: "sel_main_menu",
    icon: "7",
    showSelects: true,
    accessId: ids.sel,
    route: paths.agendaSel,
    subMenu: [],
    noExpand: true,
  },
  {
    name: "Mi Cuenta",
    stackBottom: true,
    icon: "q",
    tourId: "mi_cuenta_main_menu",
    route: paths.perfil,
    description: 'Accede y modifica tus datos personales, junto con solicitar roles dentro de la plataforma. ',
    subMenu: [
      {
        name: "Mi perfil",
        route: paths.perfil,
        icon: "q",
        tourId: "mi_cuenta_mi_cuenta",
      },
      //Comentar item menu notificaciones
      // {
      //   name: "Notificaciones",
      //   route: paths.configHistorialUsuario,
      //   icon: "o",
      //   tourId: "mi_cuenta_notificaciones",
      //   accessId: ids.miCuentaNotificaciones,
      // },
      {
        name: "Solicitudes",
        route: paths.solicitudesTrabajador,
        icon: "m",
        tourId: "mi_cuenta_solicitudes",
      },
      {
        name: "Empresas ACHS",
        route: paths.empresasAchs,
        icon: "D",
        tourId: "mi_cuenta_empresas_achs",
        accessId: ids.empresasAchs,
      },
      {
        name: "Contact Center",
        route: paths.contactCenter,
        tourId: "mi_cuenta_empresas_achs",
        icon: "F",
        accessId: ids.contactCenter,
      },
    ],
  },

  {
    name: "Mantenedor",
    icon: "G",
    route: paths.mantenedores,
    tourId: "mantenedores_main_menu",
    accessId: ids.mantenedores,
    subMenu: [
      {
        name: "General",
        route: paths.mantenedores,
        icon: "H  ",
        tourId: "mantenedores_general",
        accessId: ids.mantenedorGeneral,
      },
      // {
      //   name: "Notificaciones",
      //   route: paths.configuracionNotificaciones,
      //   icon: "o",
      //   tourId: "mantenedores_notificaciones",
      //   accessId: ids.mantenedorNotificaciones,
      // },
      {
        name: "SEL",
        route: paths.mantenedoresSel,
        icon: "7",
        tourId: "mantenedores_sel",
        accessId: ids.mantenedorGeneral,
      },
      {
        name: "Trabajadores ACHS",
        route: paths.trabajadoresACHS,
        icon: "C",
        tourId: "trabajadores_achs",
        accessId: ids.mantenedorGeneral,
      },
    ],
  },
];
